// pages/AboutPage/AboutPage.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaQuoteRight, FaGraduationCap, FaHandHoldingHeart, FaLightbulb } from 'react-icons/fa';
import axios from 'axios';
import { API_BASE } from '../../config/api';
import './css/AboutPage.css';

const AboutPage = () => {
  const defaultAbout = useMemo(
    () => ({
      header_title: 'من أنا؟ ولماذا هذا الموقع؟',
      header_subtitle: 'رحلة من التشتت في لندن... إلى التمكين الأكاديمي.',
      lead_text:
        'أَنَا نُهَى الحَازِمِي. عِنْدَمَا كُنْتُ أَدْرُسُ الدِّكْتُورَاه فِي جَامِعَةِ رُويَال هُولُوواي فِي لَنْدَن، وَخِلَالَ الفَصْلِ الدِّرَاسِيِّ الأَوَّلِ تَحْدِيدًا، رُزِقْتُ بِابْنَتِي جُمَانَةَ، وَبَعْدَ انْتِهَاءِ إِجَازَةِ الأُمُومَةِ وَعَوْدَتِي إِلَى الجَامِعَةِ، وَاجَهْتُ وَاقِعًا مُخْتَلِفًا؛ فَتَرَاكُمُ المَوَادِّ العِلْمِيَّةِ وَاتِّسَاعُ الفَجْوَةِ المَعْرِفِيَّةِ اسْتَدْعَيَا تَعَامُلًا هَادِئًا وَمُنَظَّمًا لِاسْتِعَادَةِ مَسَارِي الأَكَادِيمِيِّ.',
      timeline1_text:
        'وَفِي تِلْكَ الفَتْرَةِ، لَمْ يَكُنْ أَدَائِي الأَكَادِيمِيُّ فِي أَفْضَلِ حَالَاتِهِ؛ فَبَحْثِي جَاءَ ضَعِيفًا، وَتَعْبِيرِي غَيْرُ مُسْتَقِرٍّ، وَمُحَاوَلَاتِي مُتَبَاعِدَةُ الخُطَى، وَزَادَ الوَاقِعُ صُعُوبَةً حِينَ تَلَقَّيْتُ رِسَالَةً حَازِمَةً مِنْ مُشْرِفِي تُشِيرُ إِلَى تَأَخُّرِي عَنْ بَقِيَّةِ الزُّمَلَاءِ، كُنْتُ أُحَاوِلُ يَوْمِيًّا أَنْ أُرَتِّبَ مَسَارِي، أَقْرَأُ، وَأَكْتُبُ، وَأُصَحِّحُ، وَلَكِنَّ التَّقَدُّمَ كَانَ بَطِيئًا، يُشْبِهُ الحَفْرَ فِي أَرْضٍ جَافَّةٍ.',
      timeline2_text:
        'وَبَعْدَ سِتَّةِ أَشْهُرٍ مِنَ المُحَاوَلَاتِ المُتَوَاصِلَةِ لِتَرْتِيبِ مَسَارِي وَتَحْسِينِ أَدَائِي، وَصَلَنِي إِنْذَارٌ بِإِمْكَانِيَّةِ الفَصْلِ، كَانَتْ تلِكَ اللَّحْظَةَ الَّتِي شَعَرْتُ فِيهَا بِأَنَّ الأَرْضَ تَدُورُ تَحْتِي؛ لَحْظَةٌ كَاشِفَةٌ أَدْرَكْتُ فِيهَا أَنَّ عَلَيَّ إِعَادَةَ بِنَاءِ نَفْسِي أَكَادِيمِيًّا وَذِهْنِيًّا لِكَيْ لَا تَكُونَ هَذِهِ النِّهَايَةَ، بَلْ بَدَايَةَ تَحَوُّلٍ حَقِيقِيٍّ فِي رِحْلَتِي.',
      turning_intro_text:
        'وَفِي لَحْظَةِ يَأْسٍ صَامِتَةٍ، تَوَاصَلْتُ مَعَ مُخْتَصٍّ فِي الأَبْحَاثِ بِمَكْتَبَةِ لَنْدَن، قَطَعْتُ مَسَافَةَ سَاعَتَيْنِ بِالقِطَارِ لِلِقَائِهِ، وَعِنْدَمَا اطَّلَعَ عَلَى بَحْثِي،',
      dialogue_text:
        'أَشَارَ بِهُدُوءٍ إِلَى مَوَاضِعِ الخَلَلِ: هُنَا الخَطَأُ، هُنَا المَشْكِلَةُ، أَضِيفِي هَذَا، وَاحْذِفِي ذَاكِ',
      turning_outro_text:
        'جَلَسْنَا سَاعَتَيْنِ كَامِلَتَيْنِ، كَلَّفَتَانِي ٧٥٠ رِيَالًا؛ وَلَكِنَّهُمَا كَانَتَا نُقْطَةَ تَحَوُّلٍ فِي رِحْلَتِي.\nخَرَجْتُ مِنْ لِقَائِهِ وَفِي نَفْسِي وَجَعٌ ثَقِيلٌ؛ لَكِنَّنِي لِأَوَّلِ مَرَّةٍ رَأَيْتُ مَوْضِعَ الخَلَلِ بِوُضُوحٍ. بَكَيْتُ عَلَى سِتَّةِ أَشْهُرٍ ضَاعَتْ فِي المُحَاوَلَاتِ، وَبَكَيْتُ أَيْضًا لِأَنَّنِي أَخِيرًا فَهِمْتُ مَا يَجِبُ أَنْ أَفْعَلَهُ.',
      vow_quote: 'ولا طالبة لازم تمر باللي مريت فيه.',
      vow_text: 'وهنا بدأ هذا الموقع.',
      mission_image_url:
        'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?q=80&w=1000&auto=format&fit=crop',
      mission_desc1:
        'وَمِنْ هُنَا جَاءَ هَدَفُ هَذَا المَوْقِعِ: أَنْ أُقَدِّمَ خِدْمَاتِ الاسْتِشَارَاتِ البَحْثِيَّةِ وَالتَّوْجِيهِ الأَكَادِيمِيِّ لِطَالِبَاتِ الدِّرَاسَاتِ العُلْيَا، بِطَرِيقَةٍ عَمَلِيَّةٍ، إِنْسَانِيَّةٍ، وَمَبْنِيَّةٍ عَلَى خِبْرَةٍ وَاقِعِيَّةٍ عِشْتُهَا دَاخِلَ البِيئَةِ الأَكَادِيمِيَّةِ.',
      mission_desc2:
        'وَمِنْ هُنَا تَتَّضِحُ رِسَالَتِي فِي هَذَا المَكَانِ:\nأَنْ أُخْتَصِرَ عَلَيْكِ الطَّرِيقَ، وَأَحْمِيكِ مِنَ الأَخْطَاءِ المَنْهَجِيَّةِ الَّتِي عَانَيْتُ مِنْهَا، وَأُسَاعِدَكِ عَلَى فَهْمِ بَحْثِكِ بِعُمقٍ، لَا مُجَرَّدِ السَّعْيِ لِـ"إِنْهَائِهِ".',
      benefit1_text:
        'وَلِذَلِكَ، فَإِنَّ مَا تَسْتَفِيدُهُ الطَّالِبَةُ مِنِ العَمَلِ مَعِي يَتَجَاوَزُ مُجَرَّدَ تَصْحِيحِ خَطَأٍ أَوْ مُلَاحَظَةٍ عَابِرَةٍ؛ فَأَنَا أَقْتَرِبُ مِنْ مَشْكِلَةِ بَحْثِكِ لِأَفْهَمَهَا بِعُمقٍ، وَأُحَدِّدُ لَكِ مَوَاطِنَ الضَّعْفِ وَالثَّغَرَاتِ بِوُضُوحٍ.',
      benefit2_text:
        'وَأُقَدِّمُ لَكِ تَوْجِيهًا أَكَادِيمِيًّا مُنَظَّمًا يَضَعُكِ عَلَى مَسَارٍ وَاضِحٍ بَدَلَ التَّخَبُّطِ وَالْمُحَاوَلَاتِ المُتَفَرِّقَةِ.',
      benefit3_text:
        'هَذَا النَّهْجُ لَا يُسَاعِدُكِ فَقَطْ عَلَى اخْتِصَارِ الوَقْتِ وَالجُهْدِ الدِّرَاسِيِّ، بَلْ يَبْنِي لَكِ ثِقَةً حَقِيقِيَّةً بِنَفْسِكِ وَبِبَحْثِكِ، لِتُكْمِلِي رِحْلَتَكِ الأَكَادِيمِيَّةَ بِثَبَاتٍ وَوُضُوحٍ.',
      cta_title: 'جاهزة لتبدئي رحلة بحثية واثقة؟',
      cta_button_text: 'احجزي استشارتك الآن',
      cta_button_link: '/booking',
    }),
    []
  );

  const [about, setAbout] = useState(defaultAbout);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API_BASE}/api/about`)
      .then((res) => {
        const db = res.data?.about;
        if (!mounted) return;
        setAbout(db ? { ...defaultAbout, ...db } : defaultAbout);
      })
      .catch(() => {
        if (!mounted) return;
        setAbout(defaultAbout);
      });
    return () => {
      mounted = false;
    };
  }, [defaultAbout]);

  // Animation Variants
  const fadeInUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } }
  };

  return (
    <div className="about-page" dir="rtl">
      
      {/* 1. Page Header */}
      <header className="about-header">
        <div className="overlay"></div>
        <div className="container relative-z">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            {about.header_title}
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
          >
            {about.header_subtitle}
          </motion.p>
        </div>
      </header>

      {/* 2. Personal Story Section */}
      <section className="story-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              
              <motion.div 
                className="story-intro"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeInUp}
              >
                <p className="lead-text">
                  {about.lead_text}
                </p>
              </motion.div>

              <div className="timeline">
                {/* Struggle Phase */}
                <motion.div 
                  className="timeline-item"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  variants={fadeInUp}
                >
                  <div className="timeline-dot"></div>
                  <div className="timeline-content">
                    <p>
                    {about.timeline1_text}
                    </p>
                  </div>
                </motion.div>

                {/* Crisis Phase */}
                <motion.div 
                  className="timeline-item"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  variants={fadeInUp}
                >
                  <div className="timeline-dot"></div>
                  <div className="timeline-content">
                    <p>
                    {about.timeline2_text}
                    </p>
                  </div>
                </motion.div>

                {/* Turning Point Phase */}
                <motion.div 
                  className="timeline-item"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true }}
                  variants={fadeInUp}
                >
                  <div className="timeline-dot gold-dot"></div>
                  <div className="timeline-content">
                    <p>
                    {about.turning_intro_text}
                    </p>
                    <div className="dialogue-box">
                      "{about.dialogue_text}"
                    </div>
                    <p>
                    {about.turning_outro_text}
                    </p>
                  </div>
                </motion.div>
              </div>

              {/* The Vow */}
              <motion.div 
                className="the-vow"
                initial={{ scale: 0.9, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
              >
                <FaQuoteRight className="quote-icon" />
                <p className="vow-text">"{about.vow_quote}"</p>
                <p>{about.vow_text}</p>
              </motion.div>

            </div>
          </div>
        </div>
      </section>

      {/* 3. Mission & Benefits Section */}
      <section className="mission-section">
        <div className="container">
          <div className="row align-items-center">
            
            <div className="col-lg-5 mb-4 mb-lg-0">
              <div className="mission-image-wrapper">
                <img src={about.mission_image_url} alt="Academic Guidance" />
                <div className="image-border"></div>
              </div>
            </div>

            <div className="col-lg-7">
              <div className="mission-content">
                <p className="mission-desc">
                {about.mission_desc1}
                </p>
                <p className="mission-desc">
                {about.mission_desc2}
                </p>

                {/* Benefits Grid */}
                <div className="benefits-grid">
                  <div className="benefit-item">
                    <FaLightbulb className="benefit-icon" />
                    <p>
                      {about.benefit1_text}
                    </p>
                  </div>
                  <div className="benefit-item">
                    <FaGraduationCap className="benefit-icon" />
                    <p>
                      {about.benefit2_text}
                    </p>
                  </div>
                  <div className="benefit-item">
                    <FaHandHoldingHeart className="benefit-icon" />
                    <p>
                      {about.benefit3_text}
                      </p>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* CTA Strip */}
      <section className="cta-strip">
        <div className="container text-center">
          <h2>{about.cta_title}</h2>
          <Link to={about.cta_button_link || '/booking'} className="btn-cta-gold">
            {about.cta_button_text}
          </Link>
        </div>
      </section>

    </div>
  );
};

export default AboutPage;